/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	title?: string
	subtitle?: string
	/** 유지용 — Monolith 빈 상태는 늘 같은 톤이다(무시) */
	isGrey?: boolean
	/** 유지용(무시) — 아이콘을 두지 않는다 */
	iconSize?: number
	children?: React.ReactNode
}

/** 빈 상태 — 경고 아이콘 없이 문장 한두 줄. 판단은 읽는 쪽에 맡긴다 */
export const BoxEmptyView = (props: PropsType) => {
	return (
		<View css={style}>
			<View className="innerView">
				{props.title !== undefined ? <p className="title">{props.title}</p> : null}
				{props.subtitle !== undefined ? (
					<p className="subtitle">{props.subtitle}</p>
				) : null}
				{props.children && <View className="emptyViewContentView">{props.children}</View>}
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	minHeight: 160,
	fontFamily: boFont.ui,
	textAlign: 'center',

	'.innerView': {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 6,

		'.title': { margin: 0, fontSize: 14, fontWeight: 400, color: mono.dim },
		'.subtitle': { margin: 0, fontSize: 13, fontWeight: 300, color: mono.faint },
		'.emptyViewContentView': { marginTop: 12 },
	},
})
